<script setup lang="ts">
/**
 * Drive-style contextual bar shown only while selection mode is active
 * (entered by long-pressing a row/tile). Replaces the filter strip for the
 * duration — while selecting, selecting is the task.
 */
defineProps<{
  count: number;
  trash: boolean;
  /** true while the bulk action's API call is in flight — disables the buttons and shows a spinner. */
  busy?: boolean;
}>();

const emit = defineEmits<{
  cancel: [];
  remove: [];
  restore: [];
}>();
</script>

<template>
  <div class="flex items-center gap-2 rounded-xl bg-primary-container/50 py-2 pl-1 pr-2">
    <button
      type="button"
      aria-label="ยกเลิกการเลือก"
      class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-on-primary-container transition-colors active:bg-primary-container"
      @click="emit('cancel')"
    >
      <span class="material-symbols-outlined text-[22px]">close</span>
    </button>
    <span class="min-w-0 flex-1 truncate font-body-md font-medium text-on-primary-container">
      เลือกแล้ว {{ count }} รายการ
    </span>
    <button
      v-if="trash"
      type="button"
      class="flex h-9 shrink-0 items-center gap-2 rounded-full bg-primary px-4 font-label-caps text-on-primary transition-all active:scale-95 disabled:opacity-50"
      :disabled="count === 0 || busy"
      @click="emit('restore')"
    >
      <span v-if="busy" class="spin" aria-hidden="true" />
      กู้คืน
    </button>
    <button
      v-else
      type="button"
      class="flex h-9 shrink-0 items-center gap-2 rounded-full bg-error px-4 font-label-caps text-on-error transition-all active:scale-95 disabled:opacity-50"
      :disabled="count === 0 || busy"
      @click="emit('remove')"
    >
      <span v-if="busy" class="spin" aria-hidden="true" />
      ลบ
    </button>
  </div>
</template>
